import script from "./ReturnIpdPartialTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnIpdPartialTable.vue?vue&type=script&setup=true&lang=js"

import "./ReturnIpdPartialTable.vue?vue&type=style&index=0&id=62ddfbdf&lang=css"

const __exports__ = script;

export default __exports__